import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getMe(fetch: Fetch) {
  return fetch('/auth/me', { method: 'GET' }, schemas.MeResponse);
}

export const useMeQuery = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const result = await getMe(fetch);
        return result;
      } catch (err) {
        console.error(err);
      }
    }
  });
};
